import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthUtils } from 'src/services/Auth/Auth.utils';
import { appRoutes, RouteObject } from './routes.types';
import { useAuthStore } from 'src/services/Auth/Auth.store';
import { usePreLoginAuthLocation } from 'src/routes/use-pre-login-auth-location';
import { useSaveHubspotUtmLocationEffect } from 'src/lib/services/hubspot/use-hubspot-saved-utm-location';
import { useProfile } from 'src/models';

type ProtectedRouteProps = {
  route: RouteObject;
};

// TODO: This component should only be rendered once.
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ route }) => {
  const location = useLocation();
  const { isLoggedIn } = useAuthStore();
  const { rememberLocation } = usePreLoginAuthLocation();
  const profile = useProfile({ enabled: false });

  useSaveHubspotUtmLocationEffect();

  if (route.underMaintenance) {
    return <Navigate to={appRoutes.maintenance} />;
  }

  if (
    profile.isLoaded &&
    (location.pathname === appRoutes.addSubscriptionPlanSelect ||
      location.pathname === appRoutes.addSubscriptionSubscribe) &&
    !profile?.hasVerifiedEmail
  ) {
    return <Navigate to={appRoutes.authVerifyEmail} state={{ from: location }} replace />;
  }

  // will save location to locale storage in case if login occurs during external login
  if (!isLoggedIn && route.restricted?.includes('guest')) {
    return <Navigate to={appRoutes.login} state={{ from: rememberLocation(location) }} replace />;
  }

  if (isLoggedIn) {
    const userType = AuthUtils.getPayload()?.user_type;

    if (route.restricted?.includes(userType as any)) {
      return <Navigate to={appRoutes.dashboard} replace />;
    }
  }

  return (
    <route.layout>
      <Outlet />
    </route.layout>
  );
};
